// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.client

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.client.DocumentPreconsentSetting.ReaderIdentityBased
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.buildCborArray
import org.multipaz.wallet.client.DocumentPreconsentApprovedReader
import org.multipaz.wallet.client.toDataItem
import org.multipaz.wallet.client.fromDataItem

fun ReaderIdentityBased.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "aWvdRt8nZU3VWQGRDkD3cUHrrlQCxY82O8ITVz7CYOs")
val ReaderIdentityBased_cborSchemaId = ByteString(105, 107, -35, 70, -33, 39, 101, 77, -43, 89, 1, -111, 14, 64, -9, 113, 65, -21, -82, 84, 2, -59, -113, 54, 59, -62, 19, 87, 62, -62, 96, -21)

fun ReaderIdentityBased.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "ReaderIdentityBased")
    val array = this.approvedReaders.let {
        buildCborArray {
            for (value in it) {
                add(value.toDataItem())
            }
        }
    }
    builder.put("approvedReaders", array)
    return builder.end().build()
}

fun ReaderIdentityBased_fromDataItem(dataItem: DataItem): ReaderIdentityBased {
    val array0 = dataItem["approvedReaders"].let {
        buildList<DocumentPreconsentApprovedReader> {
            for (value in it.asArray) {
                add(DocumentPreconsentApprovedReader.fromDataItem(value))
            }
        }
    }
    val approvedReaders = array0
    return ReaderIdentityBased(
        approvedReaders = approvedReaders,
    )
}
